var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "wrapper", class: _vm.$i18n.locale },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "logo" }, [
          _c("img", {
            staticClass: "header-logo",
            attrs: {
              src: require("@/assets/img/logo.png"),
              alt: _vm.$t("topPage.altText.logo").toString(),
            },
          }),
        ]),
        _c(
          "div",
          [
            _c(
              "router-link",
              {
                staticClass: "sign-up-button",
                attrs: { to: { name: "signUp" } },
              },
              [_vm._v(_vm._s(_vm.$t("topPage.buttonText.signUp")))]
            ),
            _c(
              "router-link",
              {
                staticClass: "login-button",
                attrs: { to: { name: "signIn" } },
              },
              [_vm._v(" " + _vm._s(_vm.$t("common.login")) + " ")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "containar-fluid" }, [
        _c(
          "div",
          { staticClass: "top-contents", class: _vm.$i18n.locale },
          [
            _c("p", {
              staticClass: "catchcopy-line",
              class: _vm.$i18n.locale,
              domProps: {
                innerHTML: _vm._s(_vm.$t("topPage.topMessage.catchcopyLine1")),
              },
            }),
            _c("p", {
              staticClass: "catchcopy-line catchcopy-line2",
              class: _vm.$i18n.locale,
              domProps: {
                innerHTML: _vm._s(_vm.$t("topPage.topMessage.catchcopyLine2")),
              },
            }),
            _c(
              "router-link",
              {
                staticClass: "sign-up-button",
                attrs: { to: { name: "signUp" } },
              },
              [_vm._v(_vm._s(_vm.$t("topPage.buttonText.start")))]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "top-message" }, [
          _c("p", {
            staticClass: "top-message-title",
            domProps: { innerHTML: _vm._s(_vm.$t("topPage.topMessage.title")) },
          }),
          _c("p", {
            staticClass: "top-message-content",
            domProps: { innerHTML: _vm._s(_vm.$t("topPage.topMessage.body")) },
          }),
          _c("p", {
            staticClass: "top-message-content top-message-description",
            class: _vm.$i18n.locale,
            domProps: {
              innerHTML: _vm._s(_vm.$t("topPage.topMessage.description")),
            },
          }),
        ]),
        _c("div", { staticClass: "row row-gray" }, [
          _c("div", { staticClass: "col-lg-9-l" }, [
            _c("img", {
              staticClass: "service-img",
              attrs: {
                src: require("@/assets/img/static/service-img.webp"),
                alt: _vm.$t("topPage.altText.catchCopy").toString(),
              },
            }),
          ]),
          _c("div", { staticClass: "col-lg-3-r" }, [
            _c("div", { staticClass: "service-txt" }, [
              _c("img", {
                staticClass: "main-logo",
                attrs: {
                  src: require("@/assets/img/logo.png"),
                  alt: _vm.$t("topPage.altText.logo").toString(),
                },
              }),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("topPage.service.description")),
                },
              }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3-l" }, [
            _c("div", { staticClass: "screenshot-txt" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("topPage.features.plot.title")))]),
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("topPage.features.plot.subtitle"))),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("topPage.features.plot.description"))),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "col-lg-9-r" }, [
            _c("img", {
              staticClass: "screenshot pc",
              attrs: {
                src: require("@/assets/img/static/service-screen-plot.webp"),
                alt: _vm.$t("topPage.altText.catchCopy").toString(),
              },
            }),
            _c("img", {
              staticClass: "screenshot sp",
              attrs: {
                src: require("@/assets/img/static/service-sp-screen-plot.webp"),
                alt: _vm.$t("topPage.altText.catchCopy").toString(),
              },
            }),
          ]),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3-l sp" }, [
            _c("div", { staticClass: "screenshot-txt" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("topPage.features.character.title"))),
              ]),
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("topPage.features.character.subtitle"))),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("topPage.features.character.description"))
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "col-lg-9-l" }, [
            _c("img", {
              staticClass: "screenshot pc",
              attrs: {
                src: require("@/assets/img/static/service-screen-character.webp"),
                alt: _vm.$t("topPage.altText.catchCopy").toString(),
              },
            }),
            _c("img", {
              staticClass: "screenshot sp",
              attrs: {
                src: require("@/assets/img/static/service-sp-screen-character.webp"),
                alt: _vm.$t("topPage.altText.catchCopy").toString(),
              },
            }),
          ]),
          _c("div", { staticClass: "col-lg-3-r pc" }, [
            _c("div", { staticClass: "screenshot-txt" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("topPage.features.character.title"))),
              ]),
              _c("h3", [
                _vm._v(
                  _vm._s(_vm.$t("topPage.features.character.subtitleAlt"))
                ),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("topPage.features.character.description"))
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3-l" }, [
            _c("div", { staticClass: "screenshot-txt" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("topPage.features.editor.title"))),
              ]),
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("topPage.features.editor.subtitle"))),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("topPage.features.editor.description"))),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "col-lg-9-r" }, [
            _c("img", {
              staticClass: "screenshot pc",
              attrs: {
                src: require("@/assets/img/static/service-screen-editor.webp"),
                alt: _vm.$t("topPage.altText.catchCopy").toString(),
              },
            }),
            _c("img", {
              staticClass: "screenshot sp",
              attrs: {
                src: require("@/assets/img/static/service-sp-screen-editor.webp"),
                alt: _vm.$t("topPage.altText.catchCopy").toString(),
              },
            }),
          ]),
        ]),
        _c("div", { staticClass: "vision-contents", class: _vm.$i18n.locale }, [
          _c("p", {
            staticClass: "vision",
            class: _vm.$i18n.locale,
            domProps: { innerHTML: _vm._s(_vm.$t("topPage.vision.line1")) },
          }),
          _c("p", {
            staticClass: "vision vision-line2",
            class: _vm.$i18n.locale,
            domProps: { innerHTML: _vm._s(_vm.$t("topPage.vision.line2")) },
          }),
        ]),
        _c(
          "div",
          { staticClass: "registration" },
          [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("topPage.registration.title")),
              },
            }),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("topPage.registration.description")),
              },
            }),
            _c(
              "router-link",
              {
                staticClass: "sign-up-button",
                attrs: { to: { name: "signUp" } },
              },
              [_vm._v(_vm._s(_vm.$t("topPage.buttonText.signUp")))]
            ),
            _c(
              "router-link",
              {
                staticClass: "login-button",
                attrs: { to: { name: "signIn" } },
              },
              [_vm._v(_vm._s(_vm.$t("common.login")))]
            ),
          ],
          1
        ),
      ]),
      _c("site-footer", { attrs: { "show-links": true } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }